// extracted by mini-css-extract-plugin
export var header = "header-module--header--2K2b3";
export var logo = "header-module--logo--3tWQ2";
export var navItem = "header-module--navItem--27r1q";
export var navItemI18n = "header-module--navItemI18n--1Zctg";
export var divider = "header-module--divider--3LHlj";